import { IonItem, IonItemDivider, IonLabel, IonList } from "@ionic/react";
import { useHistory, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import WithFab from "../../hoc/with-fab";
import WithNavigation from "../../hoc/with-navigation";
import { home } from "ionicons/icons";
import { useSystem } from "../../store/system";

import "./styles.css";


const TrawlSystems = () => {
	const { systemId } = useParams<any>();
	const history = useHistory();

	const systemStore = useSystem();

	const { t } = useTranslation();

	return (
		<>
			<WithNavigation preventGoBack={false} text={t("system.trawlSystems.title")}>
				<IonList className="menuList">
					<IonItemDivider className="menuList__divider">
						<IonLabel>{t("system.trawlSystems.simple")}</IonLabel>
					</IonItemDivider>
					<IonItem
						onClick={() => history.push(`/system/${systemId}/demersals`)}
					>
						<IonLabel>{t("system.trawlSystems.demersals.title")}</IonLabel>
					</IonItem>
					<IonItem
						onClick={() => history.push(`/system/${systemId}/crustacean`)}
						lines="none"
					>
						<IonLabel>{t("system.trawlSystems.crustacean.title")}</IonLabel>
					</IonItem>
					<IonItemDivider className="menuList__divider">
						<IonLabel>{t("system.trawlSystems.doubleNet")}</IonLabel>
					</IonItemDivider>
					<IonItem
						onClick={() => history.push(`/system/${systemId}/triple-tow`)}
					>
						<IonLabel>{t("system.trawlSystems.tripleTow.title")}</IonLabel>
					</IonItem>
					<IonItem
						onClick={() => history.push(`/system/${systemId}/double-tow`)}
						lines="none"
					>
						<IonLabel>{t("system.trawlSystems.doubleTow.title")}</IonLabel>
					</IonItem>
					<IonItemDivider className="menuList__divider">
						<IonLabel>{t("system.trawlSystems.others")}</IonLabel>
					</IonItemDivider>
					<IonItem onClick={() => history.push(`/system/${systemId}/pair`)}>
						<IonLabel>{t("system.trawlSystems.pair.title")}</IonLabel>
					</IonItem>
					<IonItem onClick={() => history.push(`/system/${systemId}/tangones`)}>
						<IonLabel>{t("system.trawlSystems.tangones.title")}</IonLabel>
					</IonItem>
				</IonList>
			</WithNavigation>
		</>
	);
};

export default TrawlSystems;
